import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';
import {IBrand, ISegment} from '../types/Filter';

interface FilterState {
  brand: IBrand[];
  category: ISegment[];
  selectedBrand?: string;
  selectedCategory?: string;
  selectedProduct?: IProduct;
  loadingProduct: boolean;
  setProduct: (product: IProduct) => void;
  setLoadingProduct: (loading: boolean) => void;
  setBrand: (brands: IBrand[]) => void;
  setCategory: (categories: ISegment[]) => void;
  setSelectedBrand: (categories: string) => void;
  setSelectedCategory: (categories: string) => void;
  clearFilters: () => void;
}

export const useFilterStore = create(
  persist<FilterState>(
    set => ({
      brand: [],
      category: [],
      selectedBrand: undefined,
      selectedCategory: undefined,
      selectedProduct: undefined,
      loadingProduct: false,
      setProduct: (product: IProduct) => set(() => ({selectedProduct: product})),
      setLoadingProduct: (loading: boolean) =>
        set(() => ({loadingProduct: loading})),
      setBrand: (brands: IBrand[]) => set(() => ({brand: brands})),
      setCategory: (categories: ISegment[]) =>
        set(() => ({category: categories})),
      setSelectedBrand: (brand: string) => set(() => ({selectedBrand: brand})),
      setSelectedCategory: (category: string) => set(() => ({selectedCategory: category, selectedBrand: undefined})),
      clearFilters: () =>
        set(() => ({
          // brand: [],
          selectedBrand: undefined,
          selectedCategory: undefined,
          selectedProduct: undefined,
        })),
    }),

    {
      name: 'filter_store',
      version: 2,
      // brand and category are API-fetched lists — exclude from disk persistence
      // so they're always refreshed per session and never go stale.
      partialize: (state) => ({
        selectedBrand: state.selectedBrand,
        selectedCategory: state.selectedCategory,
        selectedProduct: state.selectedProduct,
      }) as FilterState,
      migrate: (persisted) => {
        const s = persisted as Partial<FilterState>;
        delete s.brand;
        delete s.category;
        return s as FilterState;
      },
      storage: createJSONStorage(() => AsyncStorage),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.clearFilters();
        }
      },
    }
  ),
);
